export var prod = {
    samelogicApiBaseUrl: 'https://api.samelogic.com'
};
export var dev = {
    samelogicApiBaseUrl: 'https://localhost:5000'
};
export function getConfig(options) {
    return {
        samelogicApiBaseUrl: options.baseUrl || prod.samelogicApiBaseUrl
    };
}
//# sourceMappingURL=Configs.js.map